module.exports = __webpack_public_path__ + "img/bloodpressure_150x150.624d15af.png";